module.exports = __webpack_public_path__ + "img/2.9f9a57ef.png";